import { c as _c } from "react/compiler-runtime";
import SContentWrapper from "src/components/contentwrapper/ContentWrapper";
import withWatchlist from "src/components/filmwebid/withWatchlist";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import SearchContentItem from "src/components/search/SearchContentItem";
import type { WatchableContent } from "src/lib/movieinfo/movieinfotypes";
import type { ISearchResult } from "src/lib/types/search";
import styles from "./SearchContentList.module.css";
import { locale } from "@locale";

//#region [Props]
type SearchContentListProps = {
  itemClickTracker: (id: string | number, title: string) => void;
  forceStreaming?: boolean;
  isSearching: boolean;
  contentList?: ISearchResult[] | WatchableContent[] | null;
  azShowScore?: boolean;
};
//#endregion

//#region [Component]
export default function SearchContentList(t0) {
  const $ = _c(12);
  const {
    contentList,
    itemClickTracker,
    forceStreaming: t1,
    isSearching,
    azShowScore: t2
  } = t0;
  const forceStreaming = t1 === undefined ? false : t1;
  const azShowScore = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 className={styles.SSectionTitle}>{locale.search.results}</h1>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== isSearching) {
    t4 = isSearching && <LoadingIndicator position="InlineCenter" label={"Henter s\xF8keresultat"} size="large" />;
    $[1] = isSearching;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== azShowScore || $[4] !== contentList || $[5] !== forceStreaming || $[6] !== isSearching || $[7] !== itemClickTracker) {
    t5 = !isSearching && contentList && <div className={styles.SContentContainer}>{contentList.length === 0 && <p className={styles.SNoHits}>{locale.search.noresults}</p>}{contentList.map(item => {
        const anyItem = item as any;
        const key = `${anyItem.movieId}_${anyItem.streamingContentId}_${anyItem.document?.edi}_${anyItem.document?.id}_anyItem.document?.streamingId`;
        return <WLSearchContentItem key={key} content={item} clickTracker={itemClickTracker} forceStreaming={forceStreaming} wlcClassName="contentItem" azShowScore={azShowScore} />;
      })}</div>;
    $[3] = azShowScore;
    $[4] = contentList;
    $[5] = forceStreaming;
    $[6] = isSearching;
    $[7] = itemClickTracker;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <SContentWrapper as="section" className={styles.SSearchContentList}>{t3}{t4}{t5}</SContentWrapper>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
//#endregion

const WLSearchContentItem = withWatchlist(SearchContentItem, "content");